import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit } = measures

const commonFrontBackProps = `
  position: absolute;

  background-color: ${colors.white100};

  min-width: ${20 * unit}px;
  min-height: ${30 * unit}px;

  backface-visibility: hidden;

  border: 1px solid ${colors.grays.gray3};
  border-radius: 16px;

  overflow: hidden;
`

export const cardInner = css`
  position: relative;

  width: 100%;
  height: 100%;

  text-align: center;

  transition: transform 0.6s;
  transform-style: preserve-3d;

  box-shadow: 0 4px 8px 0 ${colors.black5};
`

export const card = css`
  display: inline-block;

  min-width: ${20 * unit}px;
  min-height: ${30 * unit}px;

  background-color: transparent;

  &:hover > div {
    transform: rotateY(180deg);
  }
`

export const cardFront = css`
  ${commonFrontBackProps}
`

export const cardBack = css`
  ${commonFrontBackProps}
  transform: rotateY(180deg);
`
